import React from "react";
import {CustomThemeContext} from "js/common/themes/CustomThemeProvider";

const GridTooltip = ({value}) => {
  const {theme} = React.useContext(CustomThemeContext);

  if (value == null || value === "") {
    return null;
  }

  return (
      <div
          style={{
            borderRadius: 5,
            background: theme.palette.text.main,
            color: theme.palette.text.inverted,
            padding: "6px 10px",
            fontSize: 12,
            maxWidth: 300,
            wordBreak: "break-word"
          }}>
        {value}
      </div>
  );
};

export default GridTooltip;
